import './AccountInfoAdvisorConfig';
import { useTranslation } from 'react-i18next';

import { ProfileContainer, ProfileDetails } from './AccountInfoStyles';
import AtomAvatar from '../../../components/atoms/AtomAvatar/AtomAvatar';
import AtomTypography from '../../../components/atoms/AtomTypography/AtomTypography';
import { styleConfigs } from '../../../components/resources/styleConfigs';
import icons from '../../../constants/icons';
import userAuth from '../../../hooks/userAuth';
import palette from '../../../theme/learnerPalette';

const AccountInfo: React.FC = () => {
  const { auth } = userAuth();
  const locationName =
    auth?.userRole === 'admin' ? auth?.advisor?.institutionName : auth?.studentInstitution?.institutionName;
  const { t } = useTranslation('AdvisorAccountInfo');

  return (
    <ProfileContainer>
      <AtomAvatar
        alt="User"
        src={icons.DEFAULT_UNIVERSITY_AVATAR}
        sx={{
          width: styleConfigs.dimensions.width100,
          height: styleConfigs.dimensions.height100,
          border: `${styleConfigs.borders.borderLine2px} ${palette.light.borders.platinum}`,
          borderRadius: styleConfigs.borders.radius10rem,
        }}
      />
      <ProfileDetails>
        <AtomTypography
          component="p"
          fontFamily={styleConfigs.fonts.fontFamily}
          fontWeight={700}
          fontSize={styleConfigs.fonts.fontSize1rem}
          color={palette.light.text.black}
        >
          {auth?.displayName ?? t('GUEST_DISPLAYNAME')}
        </AtomTypography>
        <AtomTypography
          component="p"
          fontFamily={styleConfigs.fonts.fontFamily}
          fontWeight={400}
          fontSize={styleConfigs.fonts.fontSize0p9rem}
          color={palette.light.text.mistBlue}
          sx={{ marginTop: `${styleConfigs.marginPadding.customNegative2}px` }}
        >
          {auth?.username ?? t('GUEST_DISPLAYNAME')}
        </AtomTypography>
        <AtomTypography
          component="p"
          fontFamily={styleConfigs.fonts.fontFamily}
          fontWeight={400}
          fontSize={styleConfigs.fonts.fontSize0p7rem}
          color={palette.light.text.mistBlue}
          sx={{ marginTop: styleConfigs.marginPadding.custom10rem }}
        >
          {t('LOCATION')}
        </AtomTypography>
        <AtomTypography
          component="p"
          fontFamily={styleConfigs.fonts.fontFamily}
          fontWeight={400}
          fontSize={styleConfigs.fonts.fontSize0p9rem}
          color={palette.light.text.black}
        >
          {locationName ?? t('DEFAULT_LOCATION')}
        </AtomTypography>
      </ProfileDetails>
    </ProfileContainer>
  );
};

export default AccountInfo;
